import styled from '@emotion/styled';
import * as React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

interface IGroupsProfileTriggerProps {
  children: React.ReactNode;
  onClick: (event: any) => void;
  onHidePopup: () => void;
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
`;

const GroupsProfileTrigger: React.FC<IGroupsProfileTriggerProps> = ({
  children,
  onClick,
  onHidePopup
}) => {
  return (
    <ClickAwayListener onClickAway={onHidePopup}>
      <Container onClick={onClick}>{children}</Container>
    </ClickAwayListener>
  );
};

export default GroupsProfileTrigger;
